import axios from "axios";
import route from "ziggy-js";
import { toast } from "@/SharedComponents/Toaster";
import { useI18n } from "vue-i18n";
import { useFilters } from "@/Composables/useFilters";
import { storeToRefs } from "pinia";
import { computed } from "vue";

export function useSpaces() {
    const { t } = useI18n();

    const globalFilterStore = useFilters("global");
    const { filterValues: globalFilterValues } = storeToRefs(globalFilterStore);

    const tenantId = computed(() => globalFilterValues.value.tenant?.[0] || "");

    async function deleteSpace(id, callback) {
        axios
            .delete(
                route("api.spaces.delete", {
                    id: id,
                })
            )
            .then(() => {
                // Show success toast
                toast.success(t("toasts.spaces.delete.success"));

                // Callback function
                if (typeof callback === "function") {
                    callback();
                }
            })
            .catch(() => {
                // Show error toast
                toast.error(t("toasts.error"));
            });
    }

    async function addSpace(names, parentId, callback) {
        axios
            .post(route("api.spaces.add"), {
                names: names,
                parent_id: parentId,
                tenant_id: tenantId.value,
            })
            .then(() => {
                // Show success toast
                toast.success(t("toasts.spaces.add.success", names.length));

                // Callback function
                if (typeof callback === "function") {
                    callback();
                }
            })
            .catch(() => {
                // Show error toast
                toast.error(t("toasts.error"));
            });
    }

    async function duplicateSpace(id, callback) {
        axios
            .post(route("api.spaces.duplicate"), {
                id: id,
            })
            .then(() => {
                // Show success toast
                toast.success(t("toasts.spaces.duplicate.success"));

                // Callback function
                if (typeof callback === "function") {
                    callback();
                }
            })
            .catch(() => {
                // Show error toast
                toast.error(t("toasts.error"));
            });
    }

    async function updateSpace(name, identifier, id, callback) {
        axios
            .put(route("api.spaces.update"), {
                name: name,
                identifier: identifier,
                id: id,
            })
            .then(() => {
                // Show success toast
                toast.success(t("toasts.spaces.update.success"));

                // Callback function
                if (typeof callback === "function") {
                    callback();
                }
            })
            .catch(() => {
                // Show error toast
                toast.error(t("toasts.error"));
            });
    }

    async function moveSpace(id, parentId, callback) {
        axios
            .put(route("api.spaces.move"), {
                id: id,
                parent_id: parentId,
            })
            .then(() => {
                // Show success toast
                toast.success(t("toasts.spaces.move.success"));

                // Callback function
                if (typeof callback === "function") {
                    callback();
                }
            })
            .catch(() => {
                // Show error toast
                toast.error(t("toasts.error"));
            });
    }

    return {
        deleteSpace,
        addSpace,
        updateSpace,
        moveSpace,
        duplicateSpace,
    };
}
